import React from "react";
import { Container } from "react-bootstrap";
import LeafletMap from "./Leaflet/LeafletMap";

const ShowMap = () => {
  return (
    <>
      <Container>
        <LeafletMap />
      </Container>
    </>
  );
};

export default ShowMap;
